export default "__VITE_ASSET__3e2ae26f__"